import React from "react";

// Light-mode optimized: darker text on a tinted background.
const MAP = {
  erstellt:   { label: "Erstellt",   bg: "rgba(82,82,91,0.08)",   text: "#3F3F46", border: "rgba(82,82,91,0.25)" },
  geplant:    { label: "Geplant",    bg: "rgba(212,175,55,0.14)", text: "#7A5A0E", border: "rgba(212,175,55,0.40)" },
  abgeholt:   { label: "Abgeholt",   bg: "rgba(126,58,242,0.10)", text: "#6B21A8", border: "rgba(126,58,242,0.30)" },
  zwischenlager: { label: "Zwischenlager", bg: "rgba(234,88,12,0.10)", text: "#9A3412", border: "rgba(234,88,12,0.30)" },
  unterwegs:  { label: "Unterwegs",  bg: "rgba(14,165,233,0.10)", text: "#075985", border: "rgba(14,165,233,0.30)" },
  zugestellt: { label: "Zugestellt", bg: "rgba(34,197,94,0.10)",  text: "#15803D", border: "rgba(34,197,94,0.35)" },
  storniert:  { label: "Storniert",  bg: "rgba(220,38,38,0.08)",  text: "#B91C1C", border: "rgba(220,38,38,0.30)" },
};

export default function StatusBadge({ status }) {
  const s = MAP[status] || MAP.erstellt;
  return (
    <span
      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-sm text-[11px] font-semibold tracking-wider uppercase border"
      style={{ background: s.bg, color: s.text, borderColor: s.border }}
      data-testid={`status-${status}`}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: s.text }} />
      {s.label}
    </span>
  );
}
